import { Component, Input, OnChanges } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as _ from 'lodash';

@Component({
  selector: 'stacked-chart',
  templateUrl: './stacked.component.html',
  styleUrls: ['./stacked.component.scss'],
  animations: fuseAnimations
})
export class StackedChartComponent implements OnChanges {
  @Input() results: any[] = [];
  @Input() title: string;
  @Input() isLoading = true;
  @Input() schemePieColor = {
    domain: ['#12b886', '#ff3365']
  };
  labelColorDomain: any[] = [];
  showXAxis = true;
  showYAxis = true;
  showLegend = false;

  constructor() { }

  ngOnChanges(): void {
    if (Array.isArray(this.results)) {
      const diff = Math.ceil(this.results.length / this.schemePieColor.domain.length) - 1;

      this.labelColorDomain = this.schemePieColor.domain;
      for (let index = 0; index < diff; index++) {
        this.labelColorDomain = this.labelColorDomain.concat(this.schemePieColor.domain);
      }
    }
  }
}
